import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '@/store/redux';

interface IConfirmationLegalState {
  hasLegalInfo: boolean;
  key: string;
}

export interface ConfirmationLegalState {
  value: IConfirmationLegalState[];
  noCars: number;
  termsAndPolicyStatuses: Record<string, boolean>;
}

const initialState: ConfirmationLegalState = {
  value: [],
  noCars: 0,
  termsAndPolicyStatuses: {},
};

const SLICE_NAME = 'checkout/confirmation';

const slice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    saveConfirmationLegalInfo(
      state,
      action: PayloadAction<IConfirmationLegalState>
    ) {
      if (
        state.value.length === 0 ||
        !state.value.find((val) => val.key === action.payload.key)
      ) {
        state.value.push(action.payload);
      }
    },

    saveNumberOfCars(state, action: PayloadAction<number>) {
      state.noCars = action.payload;
    },

    saveTermsAndPolicy(
      state,
      action: PayloadAction<{ index: string; status: boolean }>
    ) {
      const { index, status } = action.payload;

      state.termsAndPolicyStatuses[index] = status;
    },

    reset() {
      return initialState;
    },
  },
});

export const {
  saveConfirmationLegalInfo,
  saveNumberOfCars,
  saveTermsAndPolicy,
  reset,
} = slice.actions;

export const getLegalInfoState = (state: RootState): ConfirmationLegalState =>
  state.pages.checkoutConfirmation;

export default slice.reducer;
